<template>
	<div class="main main-really-raised w-50 ml-auto mr-auto">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<div class="card card-signup no-shadow">
						<div class="card-header card-header-primary negative blue-grad w-50">
                  			<h4 class="card-title">{{$t('message.contracts.add_form')}}</h4>
                		</div>
						<div class="card-body px-3">
							<b-tabs pills content-class="mt-3" small v-model="current_tab">
								<b-tab :title="$t('message.contracts.contract_tab')" active>
									<span :class="['bmd-form-group mb-2 d-block form-label-group required', placeholder_status?'placeholderStatus':'', status_focused?'focused':'', $v.attis_contracts.attis_contract_status.$error?'has-danger label-floating':'']">
										<v-select-popup :indata="statuses" v-model="attis_contracts.attis_contract_status" :placeholder="$t('message.contracts.contract_status')"/>

										<!-- <v-select id="contract_status" :options="statuses" label="display_text" :class="['form-control', attis_contracts.attis_contract_status!==''?'vs--selected':'']" v-model="attis_contracts.attis_contract_status" :placeholder="$t('message.contracts.contract_status')" @focus="statusesFocused" @blur="statusesBlurred"></v-select>
										<label for="contract_status" class="form-label-group-label shorter">{{$t('message.contracts.contract_status')}}</label> -->
										<label v-if="form_error && !$v.attis_contracts.attis_contract_status.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label>
									</span>
									<div class="row">
										<div class="togglebutton other mt-md-3 form-label-group required col-md-6">
											<label class="control-label-sm">
											  <!--<span>{{$t('message.contracts.type')}}</span><br><br>-->
											  <input type="checkbox" v-model="attis_contracts.attis_contract_type">
											  <span class="toggle"></span>
											  <span class="choise_2">{{$t('message.contracts.type_buy')}}</span>
											  <span class="choise_1">{{$t('message.contracts.type_sell')}}</span>
											</label>
										</div>
										<div class="togglebutton other mt-md-3 form-label-group required col-md-6">
											<label class="control-label-sm">
											  <!--<span>{{$t('message.contracts.case')}}</span><br><br>-->
											  <input type="checkbox" v-model="attis_contracts.attis_contract_case">
											  <span class="toggle"></span>
											  <span class="choise_2">{{$t('message.contracts.case_product')}}</span>
											  <span class="choise_1">{{$t('message.contracts.case_service')}}</span>
											</label>
										</div>
									</div>
									<span :class="['bmd-form-group mb-2 d-block form-label-group required', $v.attis_contracts.attis_contract_subject.$error?'has-danger label-floating':'']">
										<input type="text" class="form-control" @blur="validateField('attis_contracts.attis_contract_subject')"  v-model="attis_contracts.attis_contract_subject" :placeholder="$t('message.contracts.subject')" autocomplete="off" style="cursor: auto;" id="contract_subject">
										<label for="contract_subject" class="form-label-group-label shorter">{{$t('message.contracts.subject')}}</label>
										<label v-if="form_error && !$v.attis_contracts.attis_contract_subject.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label>
									</span>
									<span :class="['bmd-form-group mb-2 d-block form-label-group required']">
										<textarea type="text" class="form-control" @blur="validateField('attis_contracts.attis_contract_desc')"  v-model="attis_contracts.attis_contract_desc" :placeholder="$t('message.contracts.description')" autocomplete="off" style="cursor: auto;" id="contract_description"></textarea>
										<label for="contract_description" class="form-label-group-label shorter">{{$t('message.contracts.description')}}</label>
										<!--<label for="contract_description" class="form-label-group-label shorter">{{$t('message.contracts.description')}}</label>-->
									</span>
									<div class="row">
										<div class="col-md-12 mb-2">
											<span :class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency?'placeholderStatus':'', currency_focused?'focused':'']">
												<v-select-popup type="currency" v-model="attis_contracts.attis_contract_currency" :placeholder="$t('message.contracts.currency')"/>
<!-- 												
												<v-select id="contract_currency" :options="currencies" label="display_text" :class="['form-control ', attis_contracts.attis_contract_currency.value!==''?'vs--selected':'']" v-model="attis_contracts.attis_contract_currency" :placeholder="$t('message.contracts.currency')" @focus="currenciesFocused" @blur="currenciesBlurred"></v-select>
												<label for="contract_currency" class="form-label-group-label shorter">{{$t('message.contracts.currency')}}</label> -->

											</span>
										</div>
										<div class="col-md-12">
											<span  :class="['bmd-form-group mb-2 d-block form-label-group']">
												<!-- <datepicker @focus="attis_contracts.attis_contract_deadline=' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="(attis_contracts.attis_contract_deadline==' ')?attis_contracts.attis_contract_deadline='':attis_contracts.attis_contract_deadline=attis_contracts.attis_contract_deadline" inputClass="form-control"  :disabled=is_field_readonly v-model="attis_contracts.attis_contract_deadline" :placeholder="$t('message.contracts.attis_contract_deadline')" :inputAttr="{id:'attis_contract_deadline'}" /> -->
										<!-- <label for="attis_contract_deadline" class="form-label-group-label shorter" :class="(attis_contracts.attis_contract_deadline!='' && attis_contracts.attis_contract_deadline!=null)?'topped':''">{{$t('message.contracts.attis_contract_deadline')}}</label> -->
												<datepicker value-type="YYYY-MM-DD" format="DD.MM.YYYY"  @focus="attis_contracts.attis_contract_date=' '" @blur="(attis_contracts.attis_contract_date==' ')?attis_contracts.attis_contract_date='':attis_contracts.attis_contract_date=attis_contracts.attis_contract_date" inputClass="form-control"  :disabled=is_field_readonly v-model="attis_contracts.attis_contract_date" :placeholder="$t('message.contracts.contract_date')" :inputAttr="{id:'contract_date'}" />
												<label for="contract_date" class="form-label-group-label shorter" :class="(attis_contracts.attis_contract_date!='' && attis_contracts.attis_contract_date!=null)?'topped':''">{{$t('message.contracts.contract_date')}}</label>
												<!-- <b-form-datepicker :locale="locale" v-model="attis_contracts.attis_contract_date" :placeholder="$t('message.contracts.contract_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="contract_date"></b-form-datepicker>
												<label  v-if="attis_contracts.attis_contract_date!=''"  for="contract_date" class="form-label-group-label shorter topped">{{$t('message.contracts.contract_date')}}</label> -->
											</span>
										</div>
									</div>
									<br>
									<h5>{{$t('message.contracts.products')}}</h5>
									<div class="input-group mb-3" style="width: 300px;">
										<input class="form-control" type="text" v-model="looking_for_product_number" style="height: 32px;" :placeholder="$t('message.contracts.search_by_number')"> 
										<div class="input-group-append">
											<button @click="lookForProductByNumber" class="btn btn-sm btn-outline-success">{{$t('message.contracts.search_by_number_button')}}</button>
										</div>
									</div>
									<b-table responsive striped hover :items="attis_contract_goods" :tbody-tr-class="rowClassProduct" :per-page="3" :current-page="product_page" :fields="product_fields">
										<template v-slot:cell(index)="data">
											<strong>{{ data.index+(product_page-1)*3+1 }}</strong>
										</template>
										<template v-slot:cell(attis_cg_TNVED)="data">
											<strong>{{ data.item.attis_cg_TNVED.display_text }}</strong>
										</template>
										<template v-slot:cell(attis_cg_quantity)="data">
											<strong>{{ data.value }} {{data.item.attis_cg_measures.display_text}}</strong>
										</template>
										<template v-slot:cell(attis_cg_price)="data">
											<strong>{{ addThousandsSeparator(data.value, ',') }} {{attis_contracts.attis_contract_currency.display_text}}</strong>
										</template>
										
										<template v-slot:cell(remove)="data">
											<button class="btn btn-sm btn-link text-danger" @click="removeProduct(data.index)"><i class="fa fa-times"></i></button>
										</template>
									</b-table>
									<div class="d-flex justify-content-center">
									<b-pagination
										v-if="attis_contract_goods.length/3>1"
										v-model="product_page"
										:total-rows="attis_contract_goods.length"
										:per-page="3"
										></b-pagination>
									</div>
									<transition name="slide">
										<div v-if="add_product" class="add-product-block alert-light" style="margin: 0 -1em !important">
											<span :class="['bmd-form-group mb-1 d-block form-label-group', $v.product.attis_cg_good_name.$error?'has-danger label-floating':'']">
							                    <input id="attis_cg_good_name" type="text" class="form-control " v-model="product.attis_cg_good_name" :placeholder="$t('message.contracts.product_title')" autocomplete="off" style="cursor: auto;">
												<label for="attis_cg_good_name" class="form-label-group-label shorter">{{$t('message.contracts.product_title')}}</label>
							                    <label v-if="product_error && !$v.product.attis_cg_good_name.required" class="control-label text-danger">{{$t('message.errors.required')}}</label>
											</span>
											<div class="row">
												<div class="col-sm-12 col-md-12">
													<span :class="['bmd-form-group mb-1 d-block', $v.product.attis_cg_TNVED.$error?'has-danger label-floating':'', placeholder_tnved?'placeholderStatus':'', tnved_focused?'focused':'']">
									                    <tnved :placeholder="$t('message.contracts.product_sku')" :placeholder_name="$t('message.tnved_name')" :placeholder_code="$t('message.tnved_code')" v-model="product.attis_cg_TNVED"></tnved>
														<!-- <v-select id="contract_status" :options="tnveds" label="display_text" :class="['form-control', product.attis_cg_TNVED!==''?'vs--selected':'']" @search="fetchTNVED"  v-model="product.attis_cg_TNVED" :placeholder="$t('message.contracts.product_sku')" @focus="tnvedFocused" @blur="tnvedBlurred"></v-select> -->
									                    <label v-if="product_error && !$v.product.attis_cg_TNVED.required" class="control-label text-danger">{{$t('message.errors.required')}}</label>
													</span>
												</div>
												<!-- <div class="col-sm-12 col-md-2 mb-3">
													<button style="height: 56px; font-size: 14px;" @click="showAISearchModal()" class="btn btn-lg btn-outline-success w-100 p-0">
														<div class="row px-0 mx-0 text-nowrap justify-content-center">AI</div>
													</button>
												</div> -->
											</div>
											<div class="row mb-3">
												<div class="col-md-4">
													<span :class="['bmd-form-group mb-1 d-block']">
									                    <cleave id="contract-goods-qnt" v-model="product.attis_cg_quantity" :options="cleave" class="form-control" :placeholder="$t('message.contracts.product_qty')" autocomplete="off" style="cursor: auto;"></cleave>
													</span>
												</div>
												<div class="col-md-4">
													<span :class="['bmd-form-group mb-1 d-block form-label-group', product_focused?'focused':'']" >
													<!-- <span :class="['bmd-form-group mb-2 d-block form-label-group required', placeholder_status?'placeholderStatus':'', status_focused?'focused':'', $v.attis_contracts.attis_contract_status.$error?'has-danger label-floating':'']"> -->
														<v-select-popup type="measure" v-model="product.attis_cg_measures" :placeholder="$t('message.contracts.product_units')"/>

														<!-- <v-select id="contract_product_measures" :options="measures" label="display_text" :class="['form-control', product.attis_cg_measures!==''?'vs--selected':'']" @search="fetchMeasures"  v-model="product.attis_cg_measures" @focus="product_focused=true" @blue="product_focused=false"></v-select>
														<label for="contract_product_measures" class="form-label-group-label shorter">{{$t('message.contracts.product_units')}}</label> -->
													</span>
												</div>
												<div class="col-md-4">
													<span :class="['bmd-form-group mb-1 d-block']">
														<cleave id="contract-goods-price" v-model="product.attis_cg_price" :options="cleave" class="form-control" :placeholder="$t('message.contracts.product_unit_price')" autocomplete="off" style="cursor: auto;"></cleave>
													</span>
												</div>
											</div>
											<button id="add-goods-btn" class="btn btn-sm btn-success" @click="addProduct()" v-if="add_product">
												{{$t('message.contracts.add_product')}}
											</button>
											<button class="btn btn-sm btn-danger btn-outline-danger float-right" @click="hideAddProduct()">{{$t('message.cancel')}}</button>
										</div>
									</transition>
									<button id="add-goods-modal-btn" class="btn btn-sm btn-success btn-outline-success" @click="showAddProduct()" v-if="!add_product">
										{{$t('message.contracts.add_product')}}
									</button>
									<div class="float-md-right pt-2" v-if="!add_product">
										{{$t('message.contracts.contract_amount')}}: {{amount()}} {{attis_contracts.attis_contract_currency.display_text}}
									</div>
									<br><br>
									
									<v-select-popup type="delivery_term" v-model="attis_contracts.attis_contract_delivery_term" :placeholder="$t('message.contracts.conditions_code')"/>

									<!-- <code-value :label="$t('message.contracts.conditions')" :value_placeholder="$t('message.contracts.conditions')" :code_placeholder="$t('message.contracts.conditions_code')" type="delivery_term" v-model="attis_contracts.attis_contract_delivery_term" ></code-value> -->

									
									<!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group', placeholder_delivery?'placeholderStatus':'', delivery_focused?'focused':'']">
										
					                    <v-select id="contract_delivery_terms" :options="delivery_terms" label="display_text" :class="['form-control', attis_contracts.attis_contract_delivery_term.value!==''?'vs--selected':'']" @search="fetchDeliveryTerms"  v-model="attis_contracts.attis_contract_delivery_term" :placeholder="$t('message.contracts.conditions')" @focus="deliveryFocused" @blur="deliveryBlurred"></v-select>
					                    <label for="contract_delivery_terms" class="form-label-group-label shorter">{{$t('message.contracts.conditions')}}</label>
									</span> -->

									<!-- <code-value :label="$t('message.contracts.payment_conditions')" :value_placeholder="$t('message.contracts.payment_conditions')" :code_placeholder="$t('message.contracts.payment_conditions_code')" type="payment_type" v-model="attis_contracts.attis_contract_payment_type" ></code-value> -->

									<v-select-popup type="payment_type" v-model="attis_contracts.attis_contract_payment_type" :placeholder="$t('message.contracts.payment_conditions_code')"/>
									<!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group', payment_focused?'focused':'']">
					                    <v-select id="contract_payment_type" :options="payment_types" label="display_text" :class="['form-control', attis_contracts.attis_contract_payment_type.value!==''?'vs--selected':'']" @search="fetchPaymentType"  v-model="attis_contracts.attis_contract_payment_type" :placeholder="$t('message.contracts.payment_conditions')" @focus="paymentFocused" @blur="paymentBlurred"></v-select>
					                    <label for="contract_payment_type" class="form-label-group-label shorter">{{$t('message.contracts.payment_conditions')}}</label>
									</span> -->
									<div class="row">
										<div :class="[attis_contracts.attis_contract_contragent.value != ''?'col-7 col-md-8':'col-10 col-md-11']">
											<v-select-popup type='company' v-model="attis_contracts.attis_contract_contragent" :placeholder="$t(attis_contracts.attis_contract_type?'message.contracts.seller':'message.contracts.buyer')"/>
									 	</div>
										<div class="col-2 col-md-1">
											<button style="height: 56px;" @click="$bvModal.show('modal-add-new_user')" class="btn btn-lg px-0 btn-outline-info w-100">
												<i class="fa fa-plus"></i>
											</button>
										</div>
										<div class="col-3"  v-if="attis_contracts.attis_contract_contragent.value != ''">
											
											<button style="height: 56px;" class="btn btn-lg px-0 btn-outline-success w-100" @click="checkContragent">{{$t(attis_contracts.attis_contract_type?'message.contracts.check_seller':'message.contracts.check_buyer')}}</button>
										</div>
									 </div>
									<!-- <span :class="['bmd-form-group mb-2 mt-2 d-block form-label-group',  contragent_focused?'focused':'']">
					                   	<v-select id="contract_contragent" :options="companies" label="display_text" :class="['form-control', attis_contracts.attis_contract_contragent.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="attis_contracts.attis_contract_contragent" :placeholder="$t(attis_contracts.attis_contract_type?'message.contracts.seller':'message.contracts.buyer')" @focus="contragent_focused=true" @blur="contragent_focused=false"></v-select>
					                   	<label for="contract_contragent" class="form-label-group-label shorter">{{$t('message.contracts.buyer')}}</label>
									</span> -->
									<span :class="['bmd-form-group mb-2 d-block form-label-group']">
										<datepicker @focus="attis_contracts.attis_contract_deadline=' '" value-type="YYYY-MM-DD" format="DD.MM.YYYY" @blur="(attis_contracts.attis_contract_deadline==' ')?attis_contracts.attis_contract_deadline='':attis_contracts.attis_contract_deadline=attis_contracts.attis_contract_deadline" inputClass="form-control"  :disabled=is_field_readonly v-model="attis_contracts.attis_contract_deadline" :placeholder="$t('message.contracts.attis_contract_deadline')" :inputAttr="{id:'attis_contract_deadline'}" />
										<label for="attis_contract_deadline" class="form-label-group-label shorter" :class="(attis_contracts.attis_contract_deadline!='' && attis_contracts.attis_contract_deadline!=null)?'topped':''">{{$t('message.contracts.attis_contract_deadline')}}</label>
					                   <!-- <b-form-datepicker :locale="locale" v-model="attis_contracts.attis_contract_deadline" :placeholder="$t('message.contracts.attis_contract_deadline')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
					                   <label v-if="attis_contracts.attis_contract_deadline!=''" for="attis_contract_deadline" class="form-label-group-label shorter topped">{{$t('message.contracts.attis_contract_deadline')}}</label> -->
									</span>
									<div id="contract-is-public-toggle" class="togglebutton other mt-md-3 form-label-group col-md-6">
										<label class="control-label-sm">
										  <span>{{$t('message.contracts.is_public')}}</span><br><br>
										  <input type="checkbox" v-model="attis_contracts.attis_contract_is_public">
										  <span class="toggle"></span>
										  <span class="choise_2">{{$t('message.yes')}}</span>
										  <span class="choise_1">{{$t('message.no')}}</span>
										</label>
									</div>
									<b-button id="contract-conditions-btn" v-b-toggle.conditions variant="outline-success" size="sm">{{$t('message.contracts.conditions_tab')}}</b-button>
									<b-collapse id="conditions" class="mt-2 pt-2">
										<h5>{{$t('message.contracts.attis_contract_conditions_product_and_delivery')}}</h5>
										<div class="row">
											<div class="col-sm-12 col-md-4">
												<span :class="['bmd-form-group mb-2 d-block form-label-group', country_focused ? 'focused' : '']">
													<v-select-popup type="country" v-model="attis_contract_conditions.goods_origin_country"
														:placeholder="$t('message.contracts.attis_contract_conditions_goods_origin_country')" />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input type="text" class="form-control" v-model="attis_contract_conditions.point_of_departure"
														:placeholder="$t('message.contracts.attis_contract_conditions_point_of_departure')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_point_of_departure">
													<label for="attis_contract_conditions_point_of_departure" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_point_of_departure') }}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input type="text" class="form-control" v-model="attis_contract_conditions.destination_point"
														:placeholder="$t('message.contracts.attis_contract_conditions_destination_point')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_destination_point">
													<label for="attis_contract_conditions_destination_point" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_destination_point') }}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-12 bmd-form-group mb-2 d-block">
												<label for="attis_contract_conditions_quality_doc">{{$t('message.contracts.attis_contract_conditions_quality_doc')}}</label>
												<input id="attis_contract_conditions_quality_doc" type="file" @change="attachQualityDocFile($event)" class="form-control">
											</div>
										</div>
										<div class="row">
											<div id="attis_contract_conditions_packaging_transport_fees_included" class="col-sm-12 col-md-6">
												<div class="togglebutton other mt-md-3 form-label-group single-option-toggle-small">
													<label class="control-label">
														<input type="checkbox" v-model="attis_contract_conditions.packaging_transport_fees_included">
														<span class="toggle"></span>
														<span class="choise_2 text-nowrap">{{
															$t('message.contracts.attis_contract_conditions_packaging_transport_fees_included') }}</span>
													</label>
												</div>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_shipping_term"
														:class="['form-label-group-label shorter', attis_contract_conditions.shipping_term != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_shipping_term') }}</label>
													<cleave v-model="attis_contract_conditions.shipping_term" :options="cleave"
														id="attis_contract_conditions_shipping_term" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_shipping_term')" autocomplete="off"
														style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_days_to_receive_goods"
														:class="['form-label-group-label shorter', attis_contract_conditions.days_to_receive_goods != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_days_to_receive_goods') }}</label>
													<cleave v-model="attis_contract_conditions.days_to_receive_goods" :options="cleave"
														id="attis_contract_conditions_days_to_receive_goods" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_days_to_receive_goods')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_shipping_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.shipping_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_shipping_overdue') }}</label>
													<cleave v-model="attis_contract_conditions.shipping_overdue" :options="cleave"
														id="attis_contract_conditions_shipping_overdue" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_shipping_overdue')" autocomplete="off"
														style="cursor: auto;"></cleave>
												</span>
												<small style="display:block; margin-top: -20px;">
													{{ $t('message.contracts.attis_contract_conditions_shipping_overdue_description') }}
												</small>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_decline_due_to_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.decline_due_to_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_decline_due_to_overdue') }}</label>
													<cleave v-model="attis_contract_conditions.decline_due_to_overdue" :options="cleave"
														id="attis_contract_conditions_decline_due_to_overdue" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_decline_due_to_overdue')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_guarantee_term"
														:class="['form-label-group-label shorter', attis_contract_conditions.guaranty_term != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_guarantee_term') }}</label>
													<cleave v-model="attis_contract_conditions.guaranty_term" :options="cleave"
														id="attis_contract_conditions_guarantee_term" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_guarantee_term')" autocomplete="off"
														style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-12">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_not_accept_fine"
														:class="['form-label-group-label shorter', attis_contract_conditions.not_accept_fine != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_not_accept_fine') }}</label>
													<cleave v-model="attis_contract_conditions.not_accept_fine" :options="cleave"
														id="attis_contract_conditions_not_accept_fine" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_not_accept_fine')" autocomplete="off"
														style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<hr>
										<h5>{{$t('message.contracts.attis_contract_conditions_payment')}}</h5>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_number_of_days_for_prepayment"
														:class="['form-label-group-label shorter', attis_contract_conditions.number_of_days_for_prepayment != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_number_of_days_for_prepayment') }}</label>
													<cleave v-model="attis_contract_conditions.number_of_days_for_prepayment" :options="cleave"
														id="attis_contract_conditions_number_of_days_for_prepayment" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_number_of_days_for_prepayment')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_prepayment_percent"
														:class="['form-label-group-label shorter', attis_contract_conditions.prepayment_percent != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_prepayment_percent') }}</label>
													<cleave v-model="attis_contract_conditions.prepayment_percent" :options="cleave"
														id="attis_contract_conditions_prepayment_percent" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_prepayment_percent')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_payment_overdue"
														:class="['form-label-group-label shorter', attis_contract_conditions.payment_overdue != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_payment_overdue') }}</label>
													<cleave v-model="attis_contract_conditions.payment_overdue" :options="cleave"
														id="attis_contract_conditions_payment_overdue" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_payment_overdue')" autocomplete="off"
														style="cursor: auto;"></cleave>
												</span>
												<small style="display:block; margin-top: -20px;">
													{{ $t('message.contracts.attis_contract_conditions_payment_overdue_description') }}
												</small>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_number_of_days_for_fullpayment"
														:class="['form-label-group-label shorter', attis_contract_conditions.number_of_days_for_fullpayment != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_number_of_days_for_fullpayment') }}</label>
													<cleave v-model="attis_contract_conditions.number_of_days_for_fullpayment" :options="cleave"
														id="attis_contract_conditions_number_of_days_for_fullpayment" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_number_of_days_for_fullpayment')"
														autocomplete="off" style="cursor: auto;"></cleave>
												</span>
											</div>
										</div>
										<div class="row mt-3">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_opening_letter_deadline"
														:class="['form-label-group-label shorter', attis_contract_conditions.opening_letter_deadline != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_opening_letter_deadline') }}</label>
													<cleave v-model="attis_contract_conditions.opening_letter_deadline" :options="cleave"
														id="attis_contract_conditions_opening_letter_deadline" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_opening_letter_deadline')"
														autocomplete="off" style="cursor: auto;"></cleave>
													<small style="display:block;">
														{{ $t('message.contracts.attis_contract_conditions_opening_letter_deadline_description') }}
													</small>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-1 d-block form-label-group']">
													<label for="attis_contract_conditions_docs_deadline_after_letter"
														:class="['form-label-group-label shorter', attis_contract_conditions.docs_deadline_after_letter != '' ? 'high' : '']">{{
															$t('message.contracts.attis_contract_conditions_docs_deadline_after_letter') }}</label>
													<cleave v-model="attis_contract_conditions.docs_deadline_after_letter" :options="cleave"
														id="attis_contract_conditions_docs_deadline_after_letter" class="form-control"
														:placeholder="$t('message.contracts.attis_contract_conditions_docs_deadline_after_letter')"
														autocomplete="off" style="cursor: auto;"></cleave>
													<small style="display:block;">
														{{ $t('message.contracts.attis_contract_conditions_docs_deadline_after_letter_description') }}
													</small>
												</span>
											</div>
										</div>
										<div class="row mt-1">
											<div class="col-12">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input type="text" class="form-control" v-model="attis_contract_conditions.letter_payment_documents"
														:placeholder="$t('message.contracts.attis_contract_conditions_letter_payment_documents')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_letter_payment_documents">
													<label for="attis_contract_conditions_letter_payment_documents" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_letter_payment_documents') }}</label>
													<small style="display:block;">
														{{ $t('message.contracts.attis_contract_conditions_letter_payment_documents_description') }}
													</small>
												</span>
											</div>
										</div>
										<hr>
										<h5>{{$t('message.contracts.attis_contract_conditions_contract_details')}}</h5>
										<div class="row">
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency ? 'placeholderStatus' : '', language_focused ? 'focused' : '']">
													<v-select-popup :indata="languagesPairs" v-model="attis_contract_conditions.contract_language"
														:placeholder="$t('message.contracts.attis_contract_conditions_contract_language')" />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-2 d-block form-label-group', placeholder_currency ? 'placeholderStatus' : '', language_focused ? 'focused' : '']">
													<v-select-popup :indata="languages" v-model="attis_contract_conditions.default_lang"
														:placeholder="$t('message.contracts.attis_contract_conditions_default_lang')" />
												</span>
											</div>
											<div class="col-sm-12 col-md-4">
												<span
													:class="['bmd-form-group mb-1 d-block  form-label-group', arbitrage_country_focused ? 'focused' : '']">
													<v-select-popup type="country" v-model="attis_contract_conditions.arbitrage_country"
														:placeholder="$t('message.contracts.attis_contract_conditions_arbitrage_country')" />
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input type="text" class="form-control" v-model="attis_contract_conditions.place_of_detention"
														:placeholder="$t('message.contracts.attis_contract_conditions_place_of_detention')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_place_of_detention">
													<label for="attis_contract_conditions_place_of_detention" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_place_of_detention') }}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group']">
													<datepicker value-type="YYYY-MM-DD" format="DD.MM.YYYY"
														@focus="attis_contract_conditions.contract_term = ' '"
														@blur="(attis_contract_conditions.contract_term == ' ') ? attis_contract_conditions.contract_term = '' : attis_contract_conditions.contract_term = attis_contract_conditions.contract_term"
														inputClass="form-control" :disabled=is_field_readonly
														v-model="attis_contract_conditions.contract_term"
														:placeholder="$t('message.contracts.attis_contract_conditions_contract_term')"
														:inputAttr="{ id: 'attis_contract_conditions_contract_term' }" />
													<label for="attis_contract_conditions_contract_term" class="form-label-group-label shorter"
														:class="(attis_contract_conditions.contract_term != '' && attis_contract_conditions.contract_term != null) ? 'topped' : ''">{{
															$t('message.contracts.attis_contract_conditions_contract_term') }}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input type="text" class="form-control" v-model="attis_contract_conditions.seller_basis"
														:placeholder="$t('message.contracts.attis_contract_conditions_seller_basis')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_seller_basis">
													<label for="attis_contract_conditions_seller_basis" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_seller_basis') }}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span :class="['bmd-form-group mb-2 d-block form-label-group ']">
													<input type="text" class="form-control" v-model="attis_contract_conditions.buyer_basis"
														:placeholder="$t('message.contracts.attis_contract_conditions_buyer_basis')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_buyer_basis">
													<label for="attis_contract_conditions_buyer_basis" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_buyer_basis') }}</label>
												</span>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12 col-md-6">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input type="text" class="form-control" v-model="attis_contract_conditions.buyer_full_name"
														:placeholder="$t('message.contracts.attis_contract_conditions_buyer_full_name')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_buyer_full_name">
													<label for="attis_contract_conditions_buyer_full_name" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_buyer_full_name') }}</label>
												</span>
											</div>
											<div class="col-sm-12 col-md-6">
												<span class="bmd-form-group mb-2 d-block form-label-group">
													<input type="text" class="form-control" v-model="attis_contract_conditions.seller_full_name"
														:placeholder="$t('message.contracts.attis_contract_conditions_seller_full_name')"
														autocomplete="off" style="cursor: auto;" id="attis_contract_conditions_seller_full_name">
													<label for="attis_contract_conditions_seller_full_name" class="form-label-group-label shorter">{{
														$t('message.contracts.attis_contract_conditions_seller_full_name') }}</label>
												</span>
											</div>
										</div>
									</b-collapse>
									<br><br>
									<div class="d-block files-block">
										<label>{{$t('message.contracts.attachements')}}</label>
										<div v-for="(file, index) in files_att" class="row align-items-center border-bottom mb-4 pb-4" :key="'upl' + index">
												<div class="col-6">
														<input
																:disabled="files_loading"
																type="file"
																@change="attachFile($event, index)"
																class="mb-2"
														/>
												</div>
												<div class="col-6">
														<v-select-popup type="attach_doc_types" 
																placeholder="Document type" 
																@input="$event=>attachFileType($event, index)" 
														/>
												</div>
												<div class="col-6">
														<DateInput
																:disabled="files_loading"
																value=""
																placeholder="Date"
																@input="attachFileDate($event, index)"
																class="mb-2"
														/>
												</div>
												<div class="col-6">
														<TextInput
																:disabled="files_loading"
																placeholder="Reference Number"
																@input="attachFileReference($event, index)"
																class="mb-2"
														/>
												</div>
												<div class="col-6">
														<button
																class="btn btn-sm btn-danger text-white"
																@click="removeFile(index)"
														>
																&times; Remove file
														</button>
												</div>
										</div>
										<div>
											<button class="btn btn-sm btn-outline-success" @click="addAttachement">{{$t('message.contracts.add_attachement')}}</button>
											<br>
											<small><i>{{$t('message.contracts.add_attachement_info')}}</i></small>
										</div>
									</div>
									
									<div class="text-center mb-2 mt-4 d-md-flex align-items-center justify-content-between">
										<div class="btn-group">
											<button class="btn btn-outline-success btn-sm btn-round float-md-left btn-sm" @click="current_tab = 1">{{$t('message.contracts.find_partner')}}</button>
											<button id="save-contract-button" :class="['btn btn-success btn-sm btn-round', loading?'pl-5':'', form_error?'btn-danger':'']" @click.prevent.stop="submit"><div class="loading my-1 loading-button" v-if="loading"></div> {{$t('message.contracts.submit_button')}}<div class="ripple-container"></div></button>
										</div>
										<button class="btn btn-outline-danger btn-round float-right btn-sm mt-2 mt-md-0" @click="cancelContract">{{$t('message.cancel')}}</button>
									</div>
								</b-tab>
								<b-tab :title="$t('message.contracts.contragents_tab')" lazy>
									<contracts-contragents-search></contracts-contragents-search>
								</b-tab>
								<!--<b-tab :title="$t('message.contracts.offers_tab')" lazy>
									<div class="row">
										<div class="col-md-6">
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <cleave v-model="attis_contragents.param_1" id="param1" :options="cleave_12_digits" class="form-control" :placeholder="$t('message.contracts.find_param_1')" autocomplete="off" style="cursor: auto;"></cleave>
							                    <label for="param1" class="form-label-group-label">{{$t('message.contracts.find_param_1')}}</label>
											</span>
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <b-form-datepicker :locale="locale" v-model="attis_contragents.param_2" :placeholder="$t('message.contracts.find_param_2')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
											</span>
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <v-select id="param3" :options="params" label="display_text" :class="['form-control', attis_contragents.param_3!==''?'vs--selected':'']" v-model="attis_contragents.param_3" :placeholder="$t('message.contracts.find_param_3')"></v-select>
							                    <label for="param3" class="form-label-group-label">{{$t('message.contracts.find_param_3')}}</label>
											</span>
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <v-select id="param4" :options="params" label="display_text" :class="['form-control', attis_contragents.param_4!==''?'vs--selected':'']" v-model="attis_contragents.param_4" :placeholder="$t('message.contracts.find_param_4')"></v-select>
							                    <label for="param4" class="form-label-group-label">{{$t('message.contracts.find_param_4')}}</label>
											</span>
										</div>
										<div class="col-md-6">
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <input type="text" class="form-control" id="param5" v-model="attis_contragents.param_5" :placeholder="$t('message.contracts.find_param_5')" autocomplete="off" style="cursor: auto;">
							                    <label for="param5" class="form-label-group-label">{{$t('message.contracts.find_param_5')}}</label>
											</span>
											<span :class="['bmd-form-group mb-2 d-block form-label-group']">
							                    <input type="text" class="form-control "  id="param6" v-model="attis_contragents.param_6" :placeholder="$t('message.contracts.find_param_6')" autocomplete="off" style="cursor: auto;">
							                    <label for="param6" class="form-label-group-label">{{$t('message.contracts.find_param_6')}}</label>
											</span>
											<span :class="['bmd-form-group mb-2 d-block form-check']">
												<label class="form-check-label">
												  <input class="form-check-input" type="checkbox" v-model="attis_contragents.search_other">
												  <div>{{$t('message.contracts.search_other')}}</div>
												  <span class="form-check-sign">
												    <span class="check"></span>
												  </span>
												</label>
											</span>
										</div>
									</div>
									<button class="btn btn-success btn-round btn-sm">{{$t('message.contracts.search')}}</button>
									<br><br>
									<h5>{{$t('message.contracts.search_results')}}</h5>
									<b-table responsive :fields="search_results_fields" :items="contragents_search_results">
										<template v-slot:cell(checked)="data">
											<input type="checkbox" v-model=data.item.checked>
										</template>
									</b-table>
									<div class="text-center">
										<button class="btn btn-outline-success btn-round btn-sm mr-2">{{$t('message.contracts.save_search')}}</button>
										<button class="btn btn-success btn-round btn-sm">{{$t('message.contracts.send_notifications')}}</button>
									</div>
									<h5>{{$t('message.contracts.saved_searches')}}</h5>
									<b-table responsive :fields="saved_searches_fields" :items="saved_searches">
									</b-table>
								</b-tab>-->
								
							</b-tabs>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="modal-add-new_user" :hide-footer=true size="sm" :title="($t('message.contracts.add_'+(attis_contracts.attis_contract_type?'seller':'buyer')))" button-size="lg">
			<buyer-seller-form :type="attis_contracts.attis_contract_type?'seller':'buyer'"></buyer-seller-form>
		</b-modal>
		<b-modal id="ai-search-modal" :hide-footer=true size="lg" :title="($t('message.contracts.ai_search'))">
			<div class="form-group d-flex flex-column">
				<textarea class="form-control" id="ai-search-modal-text-area" rows="3" v-model="ai_search.ai_search_input"></textarea>
				<div class="row mt-2 justify-content-end">
					<button @click="AISearchCancel()" class="btn btn-lg btn-outline-danger p-0 d-flex justify-content-center align-items-center" style="height: 40px; font-size: 14px; width: 150px;">
						{{$t('message.cancel')}}
					</button>
					<button :disabled="ai_search.ai_search_button_disabled" class="btn btn-lg btn-outline-success p-0 ml-2 mr-3 d-flex justify-content-center align-items-center" @click="AISearch()" style="height: 40px; font-size: 14px; width: 150px;">
						<svg v-if="ai_search.ai_search_button_disabled" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner" class="svg-inline--fa fa-spinner fa-w-16 " style="width: 20px; height: 20px; animation: loader-rotate 1s linear infinite" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"></path></svg>
						<div v-else class="row px-0 mx-0 text-nowrap">
							{{$t('message.contracts.run')}}
						</div>
					</button>
				</div>
			</div>
			<div>
				{{ ai_search.ai_search_results }}
			</div>
		</b-modal>
	</div>
</template>
<script>
	var querystring = require('querystring');
	import { required } from 'vuelidate/lib/validators'
	import ClasterSelector from './../fields/claster-selector.vue'
	import { TextInput, DateInput } from '../simplements';
	export default {
		components: {ClasterSelector, TextInput, DateInput},
		name: 'contract-add-new',
		data(){
			return {
				is_field_readonly: false,
				looking_for_product_number: '',
				current_tab: 0,
				product_page: 0, 
				attis_contract_conditions: {
					packaging_transport_fees_included: false,
					goods_origin_country: {value: ''},
					point_of_departure: '',
					destination_point: '',
					prepayment_percent: '',
					number_of_days_for_prepayment: '',
					number_of_days_for_fullpayment: '',
					shipping_term: '',
					days_to_receive_goods: '',
					guaranty_term: '',
					payment_overdue: '',
					shipping_overdue: '',
					decline_due_to_overdue: '',
					arbitrage_country: {value: ''},
					contract_language: {value:'en'},
					contract_term: '',
					quality_doc: "",
					not_accept_fine: '',
					opening_letter_deadline: '',
					letter_payment_documents: '',
					docs_deadline_after_letter: '',
					default_lang: {value:'en'},
					place_of_detention: '',
					buyer_basis: '',
					seller_basis: '',
					buyer_full_name: '',
					seller_full_name: '',
				},

				language_focused: false,

				languages: [
					{value: 'ru', display_text: this.$t('message.contracts.russian')},
					{value: 'en', display_text: this.$t('message.contracts.english')},
					{value: 'cn', display_text: this.$t('message.contracts.chinese')},
				],
				languagesPairs: [
					{value: 'ru-en', display_text: this.$t('message.contracts.russian_english')},
					{value: 'ru-cn', display_text: this.$t('message.contracts.russian_chinese')},
					{value: 'en-cn', display_text: this.$t('message.contracts.english_chinese')},
				],
				country_focused: false,
				arbitrage_country_focused: false,
				attis_contracts: {
					attis_contract_owner: '',
					attis_contract_number: '',
					attis_contract_status: {
						value: 1,
						display_text: this.$t('message.contracts.status_1')
					},
					attis_contract_is_public: false,
					attis_contract_type: false,
					attis_contract_case: false,
					attis_contract_subject: '',
					attis_contract_desc: '',
					attis_contract_currency: {value: '', display_text: ''},
					attis_contract_delivery_term: {value: '', display_text: ''},
					attis_contract_date: '',
					attis_contract_payment_type: {value: '', display_text: ''},
					attis_contract_contragent: {value: '', display_text: ''},
					attis_contract_deadline: '',
				},
				attis_contragents: {
					param_1: '',
					param_2: '',
					param_3: '',
					param_4: '',
					param_5: '',
				},

				params: [
					{
						display_text: 'Param Value',
						value: 'value'
					}
				],
				search_results_fields: [
					{
						key: "id",
						label: this.$t('message.contracts.contragents_search_id')
					},
					{
						key: "country",
						label: this.$t('message.contracts.contragents_search_country')
					},
					{
						key: "name",
						label: this.$t('message.contracts.contragents_search_name')
					},
					{
						key: "contact",
						label: this.$t('message.contracts.contragents_search_contact')
					},
					{
						key: "sphere",
						label: this.$t('message.contracts.contragents_search_sphere')
					},
					{
						key: "checked",
						label: this.$t('message.contracts.contragents_search_checked')
					},
				],
				files_att: [],
				contragents_search_results: [
					{
						id: 1,
						country: "Китай",
						name: "Кандидат 1",
						contact: "xxx@xxxx.com",
						sphere: "Проиводство 1",
						checked: false
					},
					{
						id: 2,
						country: "Китай",
						name: "Кандидат 2",
						contact: "xxx@xxxx.com",
						sphere: "Проиводство 1",
						checked: false
					},
					{
						id: 3,
						country: "Россия",
						name: "Кандидат 3",
						contact: "xxx@xxxx.com",
						sphere: "Проиводство 12",
						checked: true
					},
					{
						id: 4,
						country: "Беларусь",
						name: "Кандидат 4",
						contact: "xxx@xxxx.com",
						sphere: "Услуги",
						checked: false
					}
				],
				saved_searches_fields: [
					{
						key: 'date',
						label: this.$t('message.contracts.saved_searches_date'),
					},
					{
						key: 'number_results',
						label: this.$t('message.contracts.saved_searches_number_of_results')
					}
				],
				saved_searches: [
					{
						date: '01.01.2020',
						number_results: '199'
					},{
						date: '02.01.2020',
						number_results: '99'
					},{
						date: '03.01.2020',
						number_results: '19'
					},
				],

				status_focused: false,
				placeholder_status: false,

				currency_focused: false,
				placeholder_currency: false,

				placeholder_delivery: false,
				delivery_focused: false,
				contragent_focused: false,
				countries: [],
				payment_focused: false,

				product_focused: false,

				statuses: [
					{
						value: 1,
						display_text: this.$t('message.contracts.status_1')
					},
					{
						value: 2,
						display_text: this.$t('message.contracts.status_2')
					},
					{
						value: 3,
						display_text: this.$t('message.contracts.status_3')
					},
					{
						value: 4,
						display_text: this.$t('message.contracts.status_4')
					}
				],
				currencies: [],
				add_product: false,
				product_error: false,
				loading: false,
				status: '',
				list: [],
				cleave: {
					numeral: true
				},
				cleave_12_digits: {
					numeral: false,
					numericOnly: true,
					numeralDecimalScale: 0,
					numeralPositiveOnly: true,
					blocks: [12]
				},
				fields: [
					// {
					// 	key: "buyer",
					// 	label: this.$t('message.contracts.buyer'),
					// 	sortable: true
					// },
					{
						key: "seller",
						label: this.$t('message.contracts.seller'),
						sortable: true
					},
					{
						key: "conditions",
						label: this.$t('message.contracts.conditions'),
						sortable: true
					},
					{
						key: "term",
						label: this.$t('message.contracts.term'),
						sortable: true
					},
					{
						key: "products",
						label: this.$t('message.contracts.product'),
						sortable: true
					},
					// {
					// 	key: "payment",
					// 	label: this.$t('message.contracts.payment'),
					// 	sortable: true
					// },
					// {
					// 	key: "courier",
					// 	label: this.$t('message.contracts.courier'),
					// 	sortable: true
					// },
					{
						key: 'actions',
						label: this.$t('message.contracts.actions'),
						tdClass: 'text-right'
					}

				],
				product_fields: [
					{
						key: 'cgood_no',
						label: this.$t('message.contracts.product_number'),
						sortable: false
					},
					{
						key: 'attis_cg_good_name',
						label: this.$t('message.contracts.product_title'),
						sortable: true
					},
					{
						key: 'attis_cg_TNVED',
						label: this.$t('message.contracts.product_sku'),
						sortable: true
					},
					// {
					// 	key: 'ved',
					// 	label: this.$t('message.contracts.product_ved'),
					// 	sortable: true
					// },
					{
						key: 'attis_cg_quantity',
						label: this.$t('message.contracts.product_qty'),
						sortable: true
					},
					// {
					// 	key: 'units',
					// 	label: this.$t('message.contracts.product_units'),
					// 	sortable: true
					// },
					{
						key: 'attis_cg_price',
						label: this.$t('message.contracts.product_unit_price'),
						sortable: true
					},
					{
						key: 'remove',
						label: '',
						tdClass: 'text-right'
					}
				],
				form_error: false,
				companies_tmp: '',
				companys: [],
				product: {
					attis_cg_good_name: '',
					attis_cg_TNVED: '',
					attis_cg_quantity: '',
					attis_cg_measures: '',
					attis_cg_price: '',
				},
				ai_search: {
					ai_search_input: '',
					ai_search_results: '',
					ai_search_button_disabled: false,
				},
				attis_contract_goods: [],
				details: {
					seller: '',
					public: false,
					conditions: '',
					term: '',
				},
				tnveds: [],
				tnved_focused: false,
				placeholder_tnved: false,
				measures: [],
				delivery_terms: [],
				payment_types: [],
				companies: [],
			}
		},
		methods: {
			/**
			 * determines if the row should be highlighted
			 */
			 rowClassProduct(item, type){
				
				if (!item || type !== 'row') return
				if (parseInt(item.cgood_no) === parseInt(this.looking_for_product_number)) return 'table-success'
			},
			/**
			 * looks for product in the grid by its guid
			 */
			lookForProductByNumber(){
				let index = this.attis_contract_goods.findIndex(good=>parseInt(good.cgood_no)==parseInt(this.looking_for_product_number)) + 1
				if(!index)
					index = this.looking_for_product_number

				const page = Math.ceil(index / 3)
				this.product_page = page
			},
			checkContragent() {
				axios.get(window.base+'/admin/GetBillingServiceInfo?code=1')
				.then(response=>{
					this.$bvModal.msgBoxConfirm(this.$t('message.contracts.check_contragent_price_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
			          title: this.$t('message.confirm'),
			          size: 'sm',
			          buttonSize: 'sm',
			          okVariant: 'danger',
			          okTitle: this.$t('message.yes'),
			          cancelTitle: this.$t('message.no'),
			          footerClass: 'p-2',
			          hideHeaderClose: false,
			          centered: true
			        }).then(value => {
			          	if(value){
			          		window.open(this.$router.options.base+'#/app/aml/'+(typeof this.attis_contracts.attis_contract_contragent.display_text === 'undefined'?this.attis_contracts.attis_contract_contragent:this.attis_contracts.attis_contract_contragent.display_text), '_blank');
						}
					})
				})
				
			},
			attachQualityDocFile(event){
				if(typeof event.target.files[0] !== 'undefined')
					this.attis_contract_conditions.quality_doc=event.target.files[0]
				else
					this.attis_contract_conditions.quality_doc=""
			},
			attachFileType(event, index){
				this.files_att[index].type = event.value;
			},
			attachFileDate(event, index){
				this.files_att[index].date = event;
			},
			attachFileReference(event, index){
				this.files_att[index].reference_number = event;
			},
			attachFile(event, index){
				if(typeof event.target.files[0] !== 'undefined')
					this.files_att[index].file=event.target.files[0]
			},
			removeFile(index){
				this.files_att.splice(index, 1)
			},
			addAttachement(){
				this.files_att.push({file: '', type: '', reference_number: '', date: ''})
			},
			cancelContract(){
				this.$bvModal.msgBoxConfirm(this.$t('message.contracts.close-contract'), {
		          title: this.$t('message.confirm'),
		          size: 'sm',
		          buttonSize: 'sm',
		          okVariant: 'danger',
		          okTitle: this.$t('message.yes'),
		          cancelTitle: this.$t('message.no'),
		          footerClass: 'p-2',
		          hideHeaderClose: false,
		          centered: true
		        }).then(value => {
		        	if(value){
						this.$router.push({name: 'contracts-index'})
					}
				})
			},
			addThousandsSeparator(n, thousandsSeparatorSymbol) {
			  return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol)
			},
			validateField(){

			},
			amount(){
				var amount=0
				this.attis_contract_goods.forEach(item=>{
					amount+=item.attis_cg_price*item.attis_cg_quantity
				})
				return this.addThousandsSeparator(amount.toString(), ',')
			},
			getLibrary(type, query, qty) {
				query = query.toLowerCase()
				axios.get(window.base+'/library?type='+type+'&query='+query+'&qty='+qty+'&lang='+this.$i18n.locale)
				.then(response=>{
					var var_name = type
					if(type[type.length-1]=='s'){
						var_name = type+'es'
					}else if(type[type.length-1]=='y'){
						var_name = type.substring(0, type.length-1)+'ies'
					}else{
						var_name = type+'s'
					}
					this.$data[var_name] = []
					response.data.forEach(item=>{
						if(item.value!=='··········'){
							item.display_text = item.display_text.trim()
							this.$data[var_name].push(item)
						}
					})
				})
		    },
			fetchCurrencies(){
				this.getLibrary('currency', '', 100)
			},
			fetchTNVED(search, loading){
				this.getLibrary('tnved', search, 100)
			},
			fetchMeasures(search, loading){
				this.getLibrary('measure', search, 100)
			},
			fetchDeliveryTerms(search, loading){
				this.getLibrary('delivery_term', search, 100)
			},
			fetchPaymentType(search, loading){
				this.getLibrary('payment_type', search, 100)
			},
			fetchContragents(search, loading){
				this.getLibrary('company', search, 100)
			},
			tnvedFocused(){
				this.tnved_focused = true
			},
			tnvedBlurred(){
				this.tnved_focused = false
				this.validateField('product.attis_cg_TNVED')
			},
			statusesFocused(){
				this.status_focused = true
			},
			statusesBlurred(){
				this.status_focused = false
				// this.validateField('company_status')
			},
			currenciesFocused(){
				this.currency_focused = true
			},
			currenciesBlurred(){
				this.currency_focused = false
				// this.validateField('company_status')
			},
			deliveryFocused(){
				this.delivery_focused = true
			},
			deliveryBlurred(){
				this.delivery_focused = false
				// this.validateField('company_status')
			},
			paymentFocused(){
				this.payment_focused = true
			},
			paymentBlurred(){
				this.payment_focused = false
				// this.validateField('company_status')
			},
			contragFocused(){
				this.contragent_focused = true
			},
			contragBlurred(){
				this.contragent_focused = false
				// this.validateField('company_status')
			},
			
			stringifyProducts(){
				var result = [];
				this.attis_contract_goods.forEach((product, index)=>{
					var line = ''

					line = 'product['+index+'].attis_cg_good_name='+product.attis_cg_good_name
					//adding guid index just in case
					line += '&product['+index+'].guid='
					line += '&product['+index+'].cgood_guid='
					line += '&product['+index+'].cgood_no='+(index+1)
					//eo adding guid
					line += '&product['+index+'].attis_cg_TNVED='+product.attis_cg_TNVED.value
					line += '&product['+index+'].attis_cg_quantity='+product.attis_cg_quantity
					line += '&product['+index+'].attis_cg_measures='+product.attis_cg_measures.value
					line += '&product['+index+'].attis_cg_price='+product.attis_cg_price
					result.push(line)
				})
				return result.join('&')
			},
			submit(){
				this.$v.$touch()
				if (this.$v.attis_contracts.$invalid) {
					this.form_error = true
					setTimeout(()=>{
						$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
					}, 100)
					
				} else {
					// this.form_error = false
					// this.loading = true
					// this.$bvModal.msgBoxConfirm(this.$t('message.contracts.contract_check_contragent'), {
			        //   title: this.$t('message.confirm'),
			        //   size: 'sm',
			        //   buttonSize: 'sm',
			        //   okVariant: 'danger',
			        //   okTitle: this.$t('message.yes'),
			        //   cancelTitle: this.$t('message.no'),
			        //   footerClass: 'p-2',
			        //   hideHeaderClose: false,
			        //   centered: true
			        // }).then(value => {
			        //   	if(value){
			        //   		//let routeData = this.$router.resolve({name: 'aml', {id: (typeof this.attis_contracts.attis_contract_contragent.display_text === 'undefined'?this.attis_contracts.attis_contract_contragent:this.attis_contracts.attis_contract_contragent.display_text)});
							// window.open('/#/aml/'+(typeof this.attis_contracts.attis_contract_contragent.display_text === 'undefined'?this.attis_contracts.attis_contract_contragent:this.attis_contracts.attis_contract_contragent.display_text), '_blank');
			            	// axios.get(window.base + '/document/aml?query='+).
			            	// then(response=>{
			            		// console.log(response.data)
			            		// window.open(response.data.url)
			            		//save contract
			            // 		var tmp = this.attis_contracts
						// 		tmp.attis_contract_status = tmp.attis_contract_status.value
						// 		tmp.attis_contract_payment_type = tmp.attis_contract_payment_type.value
						// 		tmp.attis_contract_currency = tmp.attis_contract_currency.value
						// 		tmp.attis_contract_delivery_term = tmp.attis_contract_delivery_term.value
						// 		tmp.attis_contract_contragent = tmp.attis_contract_contragent.value
						// 		var fd = new FormData()
						// 		var value = querystring.stringify(tmp)+'&'+this.stringifyProducts()+'&language='+this.$i18n.locale
						// 		value = value.split('&')
						// 		value.forEach(i=>{
						// 			i = i.split('=')
						// 			fd.append(decodeURI(i[0]), decodeURI(i[1]))
						// 		})
						// 		this.files_att.forEach((i, ndx)=>{
						// 			fd.append('Files['+ndx+']', i)
						// 		})
						// 		//conditions tab field
						// 		fd.append('overdue', this.attis_contract_conditions.overdue);
						// 		fd.append('packaging_transport_fees_included', this.attis_contract_conditions.packaging_transport_fees_included?1:0);
						// 		fd.append('goods_origin_country', this.attis_contract_conditions.goods_origin_country.value?this.attis_contract_conditions.goods_origin_country.value:'');
						// 		fd.append('point_of_departure', this.attis_contract_conditions.point_of_departure);
						// 		fd.append('destination_point', this.attis_contract_conditions.destination_point);
						// 		fd.append('days_to_change_price', this.attis_contract_conditions.days_to_change_price);
						// 		fd.append('prepayment_percent', this.attis_contract_conditions.prepayment_percent);
						// 		fd.append('number_of_days_for_prepayment', this.attis_contract_conditions.number_of_days_for_prepayment);
						// 		fd.append('number_of_days_for_fullpayment', this.attis_contract_conditions.number_of_days_for_fullpayment);
						// 		fd.append('overdue_term', this.attis_contract_conditions.overdue_term);
						// 		fd.append('shipping_term', this.attis_contract_conditions.shipping_term);
						// 		fd.append('total_delivery_time', this.attis_contract_conditions.total_delivery_time);
						// 		fd.append('days_to_receive_goods', this.attis_contract_conditions.days_to_receive_goods);
						// 		fd.append('days_to_quality_receive_goods', this.attis_contract_conditions.days_to_quality_receive_goods);
						// 		fd.append('transfer_of_ownership', this.attis_contract_conditions.transfer_of_ownership?1:0);
						// 		fd.append('guaranty_term', this.attis_contract_conditions.guaranty_term);
						// 		fd.append('exceeding_guaranty_term', this.attis_contract_conditions.exceeding_guaranty_term?1:0);
						// 		fd.append('payment_overdue', this.attis_contract_conditions.payment_overdue);
						// 		fd.append('shipping_overdue', this.attis_contract_conditions.shipping_overdue);
						// 		fd.append('decline_due_to_overdue', this.attis_contract_conditions.decline_due_to_overdue);
						// 		fd.append('legal_country', this.attis_contract_conditions.legal_country.value?this.attis_contract_conditions.legal_country.value:'');
						// 		fd.append('arbitrage_country', this.attis_contract_conditions.arbitrage_country.value?this.attis_contract_conditions.arbitrage_country.value:'');
						// 		fd.append('contract_language', this.attis_contract_conditions.contract_language&&this.attis_contract_conditions.value?this.attis_contract_conditions.contract_language.value:'');
						// 		fd.append('contract_term', this.attis_contract_conditions.contract_term);
						// 		fd.append('notification_term', this.attis_contract_conditions.notification_term);
						// 		//eo conditions tab field
						// 		axios.post(window.base+'/contract/add', fd, {headers: { 'Content-Type': 'multipart/form-data' }})
						// 		.then(response=>{
						// 			if(response.data == 'ok' || response.data == '"ok"'){
						// 				new Noty({
						// 	        		theme: 'light',
						// 	        		type: 'success',
						// 				    text: this.$root.$t('message.message.contract-created'),
						// 				    timeout: 5000,
						// 				}).show();
						// 				this.$router.push({name: 'contracts-index'})
						// 				this.$root.$emit('reload-contracts')
						// 			}else{
						// 				new Noty({
						// 	        		theme: 'light',
						// 	        		type: 'error',
						// 				    text: this.$root.$t('message.message.contract-not-created')+' ('+response.data+')',
						// 				    timeout: 5000,
						// 				}).show();
						// 			}
									
						// 			// alert(response.data.statusMessage)
						// 			// this.load()
						// 			this.loading = false
						// 		}).catch(error=>{
						// 			new Noty({
						//         		theme: 'light',
						//         		type: 'error',
						// 			    text: this.$root.$t('message.message.contract-not-created')+' ('+error+')',
						// 			    timeout: 5000,
						// 			}).show();
						// 			this.loading = false
						// 		})
			            // 	// })
			          	// }else{
			          		//save contract
			          		var tmp = this.attis_contracts
							tmp.attis_contract_status = tmp.attis_contract_status.value
							tmp.attis_contract_payment_type = tmp.attis_contract_payment_type.value
							tmp.attis_contract_currency = tmp.attis_contract_currency.value
							tmp.attis_contract_delivery_term = tmp.attis_contract_delivery_term.value
							tmp.attis_contract_contragent = tmp.attis_contract_contragent.value
							tmp.attis_contract_is_public = tmp.attis_contract_is_public?1:0;
							var fd = new FormData()
								var value = querystring.stringify(tmp)+'&'+this.stringifyProducts()+'&language='+this.$i18n.locale
								value = value.split('&')
								value.forEach(i=>{
									i = i.split('=')
									// fd.append(i[0], i[1])
									fd.append(decodeURI(i[0]), decodeURI(i[1]))
								})
								this.files_att.forEach((i, ndx)=>{
									fd.append('Files['+ndx+']', i.file)
									fd.append('FilesType['+ndx+']', i.type)
									fd.append('FilesNumber['+ndx+']', i.reference_number)
									fd.append('FilesDate['+ndx+']', i.date)
								})
								//conditions tab field
								fd.append('packaging_transport_fees_included', this.attis_contract_conditions.packaging_transport_fees_included?1:0);
								fd.append('goods_origin_country', this.attis_contract_conditions.goods_origin_country.value?this.attis_contract_conditions.goods_origin_country.value:'');
								fd.append('point_of_departure', this.attis_contract_conditions.point_of_departure);
								fd.append('destination_point', this.attis_contract_conditions.destination_point);
								fd.append('prepayment_percent', this.attis_contract_conditions.prepayment_percent);
								fd.append('number_of_days_for_prepayment', this.attis_contract_conditions.number_of_days_for_prepayment);
								fd.append('number_of_days_for_fullpayment', this.attis_contract_conditions.number_of_days_for_fullpayment);
								fd.append('shipping_term', this.attis_contract_conditions.shipping_term);
								fd.append('days_to_receive_goods', this.attis_contract_conditions.days_to_receive_goods);
								fd.append('guaranty_term', this.attis_contract_conditions.guaranty_term);
								fd.append('payment_overdue', this.attis_contract_conditions.payment_overdue);
								fd.append('shipping_overdue', this.attis_contract_conditions.shipping_overdue);
								fd.append('decline_due_to_overdue', this.attis_contract_conditions.decline_due_to_overdue);
								fd.append('arbitrage_country', this.attis_contract_conditions.arbitrage_country.value?this.attis_contract_conditions.arbitrage_country.value:'');
								fd.append('contract_language', this.attis_contract_conditions.contract_language.value);
								fd.append('contract_term', this.attis_contract_conditions.contract_term);
								fd.append('quality_doc', this.attis_contract_conditions.quality_doc);
								fd.append('not_accept_fine', this.attis_contract_conditions.not_accept_fine)
								fd.append('opening_letter_deadline', this.attis_contract_conditions.opening_letter_deadline)
								fd.append('letter_payment_documents', this.attis_contract_conditions.letter_payment_documents)
								fd.append('docs_deadline_after_letter', this.attis_contract_conditions.docs_deadline_after_letter)
								fd.append('default_lang', this.attis_contract_conditions.default_lang.value)
								fd.append('place_of_detention', this.attis_contract_conditions.place_of_detention)
								fd.append('seller_basis', this.attis_contract_conditions.seller_basis)
								fd.append('buyer_basis', this.attis_contract_conditions.buyer_basis)
								fd.append('buyer_full_name', this.attis_contract_conditions.buyer_full_name)
								fd.append('seller_full_name', this.attis_contract_conditions.seller_full_name)
								//eo conditions tab field
								axios.post(window.base+'/contract/add', fd, {headers: { 'Content-Type': 'multipart/form-data' }})
							.then(response=>{
								if(response.data == 'ok' || response.data == '"ok"'){
									new Noty({
						        		theme: 'light',
						        		type: 'success',
									    text: this.$root.$t('message.message.contract-created'),
									    timeout: 5000,
									}).show();
									this.$router.push({name: 'contracts-index-just-added'})
									this.$root.$emit('reload-contracts')
								}else{
									new Noty({
						        		theme: 'light',
						        		type: 'error',
									    text: this.$root.$t('message.message.contract-not-created')+' ('+response.data+')',
									    timeout: 5000,
									}).show();
								}
								this.$router.push({name: 'contracts-index-just-added'})
								this.$root.$emit('reload-contracts')
								// alert(response.data.statusMessage)
								// this.load()
								this.loading = false
							}).catch(error=>{
								new Noty({
					        		theme: 'light',
					        		type: 'error',
								    text: this.$root.$t('message.message.contract-not-created')+' ('+error+')',
								    timeout: 5000,
								}).show();
								this.loading = false
							})

					
				}
				// axios({
				// 	method: 'post',
				// 	url: '/account/register',
				// 	data: bodyFormData,
				// 	headers: {'Content-Type': 'multipart/form-data' }
				// }).then(response=>{
				// 	console.log(response.data)
				// 	alert(response.data.statusMessage)
				// })
			},
			removeProduct(index){
				this.products.splice(index, 1)
			},
			addProduct(){
				// this.hideAddProduct()
				this.$v.$touch('product')
				if (this.$v.product.$invalid) {
					this.product_error = true
					setTimeout(()=>{
						$('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
					}, 100)
					
				} else {
					this.product_error = false
					this.hideAddProduct()
					this.attis_contract_goods.push({
						cgood_no: this.attis_contract_goods.length+1,
						cgood_guid: '',
						attis_cg_good_name: this.product.attis_cg_good_name,
						attis_cg_TNVED: this.product.attis_cg_TNVED,
						attis_cg_quantity: this.product.attis_cg_quantity,
						attis_cg_measures: this.product.attis_cg_measures,
						attis_cg_price: this.product.attis_cg_price,
					})
					this.product = {
						attis_cg_good_name: '',
						attis_cg_TNVED: '',
						attis_cg_quantity: '',
						attis_cg_measures: '',
						attis_cg_price: '',
					}
					
				}

			},
			showAddProduct(){
				this.add_product = true;
			},
			hideAddProduct(){
				this.add_product = false;
			},
			load(){
				axios.get(window.base + '/contract?customer_id='+this.$store.state.user.id)
				.then(response=>{
					this.list = response.data
				})
			},
			fetchCountries(search, loading){
				this.getLibrary('country', search, 100)
			},
			AISearch(){
				if (this.ai_search.ai_search_input.length < 3) return
				this.ai_search.ai_search_button_disabled = true
				axios.get(window.base+'/library/bardapi?query='+encodeURIComponent(this.ai_search.ai_search_input)).then(response=>{
					if (this.ai_search.ai_search_button_disabled === false){
						return
					}
					this.ai_search.ai_search_results = response.data
				}).finally(()=>{
					this.ai_search.ai_search_button_disabled = false
				})
			},
			AISearchCancel(){
				this.ai_search.ai_search_button_disabled = false
				this.ai_search.ai_search_input = ""
				this.ai_search.ai_search_results = ""
			},
			showAISearchModal(){
				if(this.product.attis_cg_good_name)
					this.ai_search.ai_search_input = `What is HS code for ${this.product.attis_cg_good_name}?`;
				this.$bvModal.show('ai-search-modal');
			}
		},
		mounted(){
			if(!this.$store.state.auth)
            	this.$router.push({name: 'sign-in'})
			setTimeout(()=>{
				var el = this
				$('#attis_contract_conditions_point_of_departure').focus(function(){
					el.cus_adr = new ymaps.SuggestView('attis_contract_conditions_point_of_departure')
					el.cus_adr.events.add(['select'], (event)=>{
						// console.log(event)
						el.attis_contract_conditions.point_of_departure = event.get('item').value
					})
				})
				$('#attis_contract_conditions_destination_point').focus(function(){
					el.com_adr = new ymaps.SuggestView('attis_contract_conditions_destination_point')
					el.cus_adr.events.add(['select'], (event)=>{
						// console.log(event)
						el.attis_contract_conditions.point_of_departure = event.get('item').value
					})
					// el.com_adr.events.add(['select'], (event)=>{
					// 	el.attis_contract_conditions.destination_point = event.get('item').value
					// 	ymaps.geocode(el.attis_contract_conditions.destination_point).then(function (res) {
            		// 		var obj = res.geoObjects.get(0)
            		// 		el.attis_contract_conditions.destination_point = obj.getCountry()
            		// 	})
					// })
				})
			}, 1000)
			this.$root.$on('set.seller.contragent', (data)=>{
				this.$bvModal.hide('modal-add-new_user')
				this.attis_contracts.attis_contract_contragent = {value: data.company.number, display_text: data.company.name}
			})
			this.$root.$on('set.buyer.contragent', (data)=>{
				this.$bvModal.hide('modal-add-new_user')
				this.attis_contracts.attis_contract_contragent = {value: data.company.number, display_text: data.company.name}
			})
			if(!this.$store.state.auth){
				this.$router.push({name: 'sign-in'})
			}else{
				// this.load()
				this.fetchCurrencies()
				this.fetchCountries('')
				this.fetchTNVED('')
				this.fetchMeasures('')
				this.fetchDeliveryTerms('')
				this.fetchPaymentType('')
				this.fetchContragents('')
			}
		},
		computed: {
			locale(){
				var locale = this.$i18n.locale
				var _this = this
				switch(locale){
					case 'cn': locale = 'zh-CN'; break;
					case 'en': locale = 'en-US'; break;
				}
				return locale
			}
		},
		watch: {
			companies_tmp: _.debounce(function(query) { this.getLibrary('company', query) }, 500),
		},
		validations:{
			attis_contracts: {
				attis_contract_status:{
					required
				},
				attis_contract_type: {
					required
				},
				attis_contract_case: {
					required
				},
				attis_contract_subject: {
					required
				}
			},
			product: {
				attis_cg_good_name: {
					required,
				},
				attis_cg_TNVED: {
					required
				},
			},
		}
	}
</script>